import React, { useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { registerUser } from "../api";

import { colors, space, radius, borders } from "../design/tokens";

import {
  Screen,
  Content,
  Card,
  TextInput,
  Button,
  Text
} from "../components/layout";

const Register = () => {

    const navigate = useNavigate();

  const urlIonos = process.env.REACT_APP_BACKEND_URL;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // const handleRegister = async () => {
  //   const res = await fetch(`${urlIonos}/register`, {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify({ name, email, password })
  //   });
  //   const data = await res.json();
  //   console.log(data);
  //   // navigate("/login"); // go to login after registration
  //   navigate("/login", { replace: true });
  // };

  const handleRegister = async () => {
    try {
      const data = await registerUser({ name, email, password });
      console.log("Register RESPONSE:", data);

    } catch (err) {
      // console.error("Login error:", err.message);
      navigate("/login"); // go to protected dashboard
      // alert(err.message);
    }
  };

  const handleBack = async () => {
    // navigate("/login"); // go to login after registration
    navigate("/login", { replace: true });
  };

  return (
    <Screen>
      <Content>
        <Card style={{
          padding: space.sm,
          gap: space.lg
        }}
        >
          <Text variant="h3">Register</Text>

          <TextInput
            placeholder="Name"

            value={name}
            onChange={(e) => setName(e.target.value)}
            style={{
              background: colors.surfaceSoft,
              borderBottom: borders.sm,
              borderColor: colors.primary
            }}
          />
          <TextInput
            placeholder="Email"
    
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{
              background: colors.surfaceSoft,
              borderBottom: borders.sm,
              borderColor: colors.primary
            }}
          />
          <TextInput
            placeholder="Password"

            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              background: colors.surfaceSoft,
              borderBottom: borders.sm,
              borderColor: colors.primary
            }}
          />

          <Button onClick={handleRegister}>
            Register
          </Button>
          <Button onClick={handleBack}>
            Zurück zum Login
          </Button>

        </Card>
      </Content>
    </Screen>
  );
};

export default Register;
